import { render, staticRenderFns } from "./InstallationsItems.vue?vue&type=template&id=173fc27c&scoped=true&"
import script from "./InstallationsItems.vue?vue&type=script&lang=ts&"
export * from "./InstallationsItems.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsItems.vue?vue&type=style&index=0&id=173fc27c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173fc27c",
  null
  
)

export default component.exports